// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CountryEntityMapper from "../entity-mapper/CountryEntityMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

var execute = CountryEntityMapper.execute;

var CountryRepoConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var CountryResponseConverter = partial_arg(CountryRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  CountryRepoConfig ,
  CountryResponseConverter ,
  
}
/* CountryResponseConverter Not a pure module */
